export default __webpack_public_path__ + "static/media/no-notification.1d228856.svg";